import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import DOMPurify from 'dompurify';

import { URI_PARAM } from 'containers/ContentReporting/ContentPolicyReporting/utils/constants';

const useQueryParams = () => {
  const { search } = useLocation();
  const [searchParamsWithoutURI, uriSearchParamValue] = useMemo(() => {
    const searchParams = new URLSearchParams(search);

    const uriValue = searchParams.get(URI_PARAM) || '';
    if (searchParams.has(URI_PARAM)) {
      searchParams.delete(URI_PARAM);
    }

    return [searchParams, uriValue];
  }, [search]);

  const getURISearchString = () => {
    if (!!uriSearchParamValue) {
      const uriParamValue = DOMPurify.sanitize(uriSearchParamValue);
      return `${URI_PARAM}=${decodeURIComponent(uriParamValue)}`;
    }
    return '';
  };

  const queryParamsToSearch = () => {
    const queryParamsString = `${searchParamsWithoutURI.toString()}`;
    const uriQueryString = getURISearchString();
    const infix = !!queryParamsString.length && !!uriQueryString.length ? '&' : '';

    return `?${queryParamsString}${infix}${uriQueryString}`;
  };

  return {
    params: new URLSearchParams(search),
    search: queryParamsToSearch(),
  };
};

export default useQueryParams;
